var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_25639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 12.5C24.3856 12.2812 24.6455 12.1076 24.9314 11.9891C25.2174 11.8707 25.5239 11.8097 25.8334 11.8097C26.1429 11.8097 26.4494 11.8707 26.7354 11.9891C27.0214 12.1076 27.2812 12.2812 27.5001 12.5C27.719 12.7189 27.8926 12.9788 28.011 13.2647C28.1295 13.5507 28.1904 13.8572 28.1904 14.1667C28.1904 14.4762 28.1295 14.7827 28.011 15.0687C27.8926 15.3547 27.719 15.6145 27.5001 15.8334L16.2501 27.0834L11.6667 28.3334L12.9167 23.75L24.1667 12.5Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_25639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.a5598a51ecb0141afae690c0c2a8834e.svg";
export { ForwardRef as ReactComponent };